

export const splitString = (string, size) => !string  ? '' : string.length <= size  ? string : string.split('').slice(0,size).join('')+'...';

export const  capitalizeName =(name)=> {
  return name.replace(/\b(\w)/g, s => s.toUpperCase());
}